import { Service } from '@angular/core';
import type * as LeafletTypes from 'leaflet';

@Service()
export class LeafletService {
  private L: typeof LeafletTypes | null = null;

  async getLeaflet(): Promise<typeof LeafletTypes> {
    if (!this.L) {
      const module = await import('leaflet');
      const modRec = module as unknown as Record<string, unknown>;
      this.L = (modRec['map'] ? module : modRec['default'] || module) as unknown as typeof LeafletTypes;

      if (this.L?.Icon?.Default) {
        delete (this.L.Icon.Default.prototype as unknown as Record<string, unknown>)['_getIconUrl'];
        this.L.Icon.Default.mergeOptions({
          iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
        });
      }
    }
    return this.L;
  }
}
